import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import Select from "@client/controls/Inputs/Select/component";
import { getUnwrapResponse } from "@client/lib/api";
import { type GenericMap } from "@client/types";
import { DynamicReport, type IReport } from "@common/components/Report/component";
import React from "react";
import api from "../api";
import { type ReportModule } from "../types";

export type MapProps = RootContainerProps & {
  alwaysShowRunButton: boolean;
  apiInfo: ModuleApiInfo;

  fieldStyle: React.CSSProperties;
  itemId: string;
  moduleReportSettings: ReportModule.Settings;
  noFullScreen?: boolean;
  noGrid?: boolean;
  noRun?: boolean;
  reloadTrigger: string;
  reportId: string;
  reportOptions: ReportModule.ReportOptionItem[];
  useUrlState: boolean;
};

export type ActionProps = {
  onLoaded?: () => void;
  onChangeItem: (itemId: string) => void;
};

export default (props: ActionProps & MapProps) => {
  const [ref, setRef] = React.useState<IReport | null>(null);

  const getChartData = React.useCallback(
    (id: string, parameters: GenericMap<any>) => getUnwrapResponse(api.getChartData)(props.apiInfo, id, parameters),
    [props.apiInfo]
  );
  const getGridData = React.useCallback(
    (id: string, parameters: GenericMap<any>) => getUnwrapResponse(api.getGridData)(props.apiInfo, id, parameters),
    [props.apiInfo]
  );
  const getReport = React.useCallback(
    (id: string) => getUnwrapResponse(api.getReport)(props.apiInfo, id),
    [props.apiInfo]
  );

  return (
    <FormStyleProvider {...getEntityRef(props)}>
      <div className="controls">
        {props.reportOptions.length > 1 && (
          <Select
            className="report_select"
            onChange={props.onChangeItem}
            options={props.reportOptions}
            style={props.fieldStyle}
            value={props.itemId}
          />
        )}

        {!!ref?.fields.length && <ModuleButton {...getRootContainerProps(props)} onClick={ref?.openFilters} />}
      </div>

      <DynamicReport
        ref={setRef}
        key={props.reloadTrigger}
        alwaysShowRunButton={props.alwaysShowRunButton}
        fieldStyle={props.fieldStyle}
        id={props.reportId}
        getChartData={getChartData}
        getGridData={getGridData}
        getReport={getReport}
        options={props.reportOptions}
        settings={props.moduleReportSettings}
        useUrlState={props.useUrlState}
      />
    </FormStyleProvider>
  );
};
